export function throttle(fn, delay = 0) {
    let lastCalled = 0;
    let timer;
    const throttledFn = (...args) => {
        const remainingDelay = Math.max(0, lastCalled + delay - Date.now());
        if (remainingDelay) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                lastCalled = Date.now();
                fn(...args);
            }, remainingDelay);
        }
        else {
            lastCalled = Date.now();
            fn(...args);
        }
    };
    return Object.assign(throttledFn, {
        cancel: () => {
            lastCalled = 0;
            clearTimeout(timer);
        },
    });
}
//# sourceMappingURL=index.js.map